// extracted by mini-css-extract-plugin
export default {"theme-wrap":"ThemeMode_theme-wrap__qVRpt","theme-title":"ThemeMode_theme-title__W+Rg4","theme-toggle":"ThemeMode_theme-toggle__-F0yK","icon":"ThemeMode_icon__Kj6YO"};